import { storyblokEditable } from 'gatsby-source-storyblok';
import React from 'react';
import { MARK_LINK, NODE_PARAGRAPH, render } from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';
import Container from '../Container';
import { getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

function AchievementsSection({ blok }) {
  const { heading } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      <Container>
        {heading && heading.trim() && (
          <FancyTitle
            text={heading}
            tag="h3"
            textAlign="left"
            className="text-xl"
          />
        )}
        <div>
          {blok.achievements.map((achievement) => (
            (() => {
              const { width, height } = getStoryblokDimensions(achievement.image.filename);
              return (
            <div className="flex flex-col lg:flex-row justify-between items-center py-8 border border-r-0 border-l-0 border-t-0 border-b-black gap-10 lg:gap-40">
              <div className="lg:w-2/3 ">
                <FancyTitle
                  text={achievement.title}
                  tag="h5"
                  textAlign="left"
                  fontSize="text-xl"
                  className="mb-5"
                />
                <div className="mb-10">
                  {render(achievement.description, {
                    markResolvers: {
                      [MARK_LINK]: LinkResolver,
                    },
                    nodeResolvers: {
                      // eslint-disable-next-line react/no-unstable-nested-components
                      [NODE_PARAGRAPH]: (children) => (
                        <p className="first-of-type:mt-0 last-of-type:mb-0 m-auto my-4" style={{ fontSize: '16px' }}>{children}</p>
                      ),
                    },
                  })}
                </div>
                <div className="mb-10 lg:hidden">
                  <picture>
                    <source
                      type="image/avif"
                      srcSet={achievement.image.filename ? `${achievement.image.filename}/m/600x0/filters:format(avif) 600w, ${achievement.image.filename}/m/900x0/filters:format(avif) 900w` : undefined}
                      sizes="100vw"
                    />
                    <img
                      src={achievement.image.filename ? `${achievement.image.filename}/m/900x0/filters:format(webp)` : undefined}
                      srcSet={achievement.image.filename ? `${achievement.image.filename}/m/600x0/filters:format(webp) 600w, ${achievement.image.filename}/m/900x0/filters:format(webp) 900w` : undefined}
                      sizes="100vw"
                      alt={getStoryblokAlt(achievement.image)}
                      width={width}
                      height={height}
                      className="mx-auto max-h-[260px] object-contain"
                      loading="lazy"
                    />
                  </picture>
                </div>
              </div>
              <div className="hidden lg:block lg:w-1/3">
                <picture>
                  <source
                    type="image/avif"
                    srcSet={achievement.image.filename ? `${achievement.image.filename}/m/600x0/filters:format(avif) 600w, ${achievement.image.filename}/m/900x0/filters:format(avif) 900w, ${achievement.image.filename}/m/1200x0/filters:format(avif) 1200w` : undefined}
                    sizes="(max-width: 1280px) 33vw, 25vw"
                  />
                  <img
                    src={achievement.image.filename ? `${achievement.image.filename}/m/900x0/filters:format(webp)` : undefined}
                    srcSet={achievement.image.filename ? `${achievement.image.filename}/m/600x0/filters:format(webp) 600w, ${achievement.image.filename}/m/900x0/filters:format(webp) 900w, ${achievement.image.filename}/m/1200x0/filters:format(webp) 1200w` : undefined}
                    sizes="(max-width: 1280px) 33vw, 25vw"
                    alt={getStoryblokAlt(achievement.image)}
                    width={width}
                    height={height}
                    className="mx-auto max-h-[260px] object-contain"
                    loading="lazy"
                  />
                </picture>
              </div>
            </div>
              );
            })()
          ))}

        </div>

      </Container>
    </div>
  );
}

export default AchievementsSection;
